// extracted by mini-css-extract-plugin
export default {"elementContainer":"Queue_elementContainer__wUkT9","elements":"Queue_elements__8VaCd","element":"Queue_element__uRNt-"};